import Vue from "vue";
import App from "./App.vue";
import VueAlert from "@vuejs-pt/vue-alert";
import router from "./router";

import {DatePicker, TimePicker, TimeSelect, Form, FormItem, Input, Select, Option} from "element-ui";
import lang from "element-ui/lib/locale/lang/ko";
import Locale from 'element-ui/lib/locale';

import 'element-ui/lib/theme-chalk/index.css'
import "./styles/base.scss";

Locale.use('en');

Vue.config.productionTip = false;

Vue.use(VueAlert);

Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(TimeSelect);
Vue.use(Select);
Vue.use(Option);

Locale.use(lang);

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
